"use client";

import { Star } from "lucide-react";
import { useState } from "react";
import { cn, HStack } from "@/ui";

interface StarRatingInputProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function StarRatingInput({ value, onChange, disabled }: StarRatingInputProps) {
  const [hoverValue, setHoverValue] = useState(0);

  return (
    <HStack className="gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={disabled}
          onClick={() => onChange(star)}
          onMouseEnter={() => setHoverValue(star)}
          onMouseLeave={() => setHoverValue(0)}
          className={cn(
            "p-1 transition-colors",
            disabled
              ? "cursor-not-allowed text-muted-foreground"
              : "cursor-pointer hover:scale-110",
          )}
        >
          <Star
            className={cn(
              "w-8 h-8 transition-colors",
              (hoverValue ? star <= hoverValue : star <= value)
                ? "fill-yellow-400 text-yellow-400"
                : "text-gray-300",
            )}
          />
        </button>
      ))}
    </HStack>
  );
}
